import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListNode, ListItemNode } from '@lexical/list';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { SectionHeaderNode } from './SectionHeaderNode';
import { AttachmentNode } from './AttachmentNode';
import { ImageNode } from './ImageNode';
import { VideoNode } from './VideoNode';
import { EmbedNode } from './EmbedNode';
import { ProjectCarouselNode } from './ProjectCarouselNode';
import { ColumnsNode } from './ColumnsNode';
import { ColumnNode } from './ColumnNode';
import { HorizontalRuleNode } from './HorizontalRuleNode';
import { CelebrationNode } from './CelebrationNode';

// One node list for editor, JSON→HTML renderer and HTML→JSON migration; a node missing from one fails silently.
export const editorNodes = [
    HeadingNode,
    QuoteNode,
    ListNode,
    ListItemNode,
    LinkNode,
    AutoLinkNode,
    SectionHeaderNode,
    AttachmentNode,
    ImageNode,
    VideoNode,
    EmbedNode,
    ProjectCarouselNode,
    ColumnsNode,
    ColumnNode,
    HorizontalRuleNode,
    CelebrationNode,
];
